export default __webpack_public_path__ + "static/media/email.03e998e9.svg";